define('TescoMobile_ClubCard/js/model/abstract-clubcard-price-provider',['jquery', 'uiComponent', 'Magento_Customer/js/customer-data'], function ($, Component, customerData) {
  'use strict';

  return Component.extend({
    defaults: {
      clubCardPriceFlagSelector: 'input[name="is_clubcard"]',
      clubCardPrice: null,
      form: null
    },
    initObservable: function () {
      this._super().observe(['clubCardPrice', 'form']);
      return this;
    },
    bindForm: function (form) {
      this.form(form);
    },
    hasLinkedClubCard: function () {
      var _customer;
      const customer = customerData.get('customer');
      return Boolean((_customer = customer()) === null || _customer === void 0 ? void 0 : _customer.has_linked_clubcard);
    },
    getClubCardPriceFlagElement: function () {
      return $(this.clubCardPriceFlagSelector, this.form());
    }
  });
});

